import Box from '../Box/Box.js';
import { jsx } from 'react/jsx-runtime';

function CircleOcticon(props) {
  const {
    size = 32,
    as,
    icon: IconComponent,
    bg,
    'aria-label': ariaLabel,
    ...rest
  } = props;
  return /*#__PURE__*/jsx(Box, {
    as: as,
    bg: bg,
    overflow: "hidden",
    borderWidth: 0,
    size: size,
    borderRadius: "50%",
    borderStyle: "solid",
    borderColor: "border.default",
    children: /*#__PURE__*/jsx(Box, {
      display: "flex",
      as: as,
      size: size,
      ...rest,
      alignItems: "center",
      justifyContent: "center",
      children: /*#__PURE__*/jsx(IconComponent, {
        size: size,
        "aria-label": ariaLabel
      })
    })
  });
}
CircleOcticon.displayName = "CircleOcticon";

export { CircleOcticon as default };
